import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../shared/HubLayout.css';
import SubNav from '../layout/SubNav';
import { useMobileSubNav } from '../layout/MobileNavContext';
import Messages from './messages/Messages';
import WhatsAppMessageSamples from './samples/WhatsAppMessageSamples';
import TryIt from './tryit/TryIt';
import PhoneNumber from './phonenumber/PhoneNumber';
import SectionDescription from '../shared/SectionDescription';

const SUB_PATHS = ['samples', 'try-it', 'log', 'phone-number'];

const SECTION_INFO = [
  { titleKey: 'whatsapp_samples_section_title', textKey: 'whatsapp_samples_section_text' },
  { titleKey: 'whatsapp_tryit_section_title',   textKey: 'whatsapp_tryit_section_text' },
  { titleKey: 'whatsapp_log_section_title',     textKey: 'whatsapp_log_section_text' },
  { titleKey: 'whatsapp_phone_section_title',   textKey: 'whatsapp_phone_section_text' },
];

export const MessagesHub = () => {
  const { t } = useTranslation();
  const { subTab } = useParams();
  const navigate = useNavigate();
  const { setSubNav } = useMobileSubNav();

  const activeSubTab = Math.max(0, SUB_PATHS.indexOf(subTab));

  const subTabs = [t("samples"), t("try_it"), t("log"), t("phone_number")];

  const handleSubTabClick = (index) => navigate(`/messages/${SUB_PATHS[index]}`);

  useEffect(() => {
    setSubNav({ tabs: subTabs, activeTab: activeSubTab, onTabClicked: handleSubTabClick });
    return () => setSubNav(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSubTab, setSubNav]);

  return (
    <div className="hub">
      <div className="hub-header">
        <SubNav tabs={subTabs} activeTab={activeSubTab} onTabClicked={handleSubTabClick} />
      </div>
      <div className="hub-content">
        <SectionDescription
          title={t(SECTION_INFO[activeSubTab].titleKey)}
          text={t(SECTION_INFO[activeSubTab].textKey)}
        />
        {activeSubTab === 0 && <WhatsAppMessageSamples />}
        {activeSubTab === 1 && <TryIt />}
        {activeSubTab === 2 && <Messages />}
        {activeSubTab === 3 && <PhoneNumber />}
      </div>
    </div>
  );
};

export default MessagesHub;
